<div class="relative bg-black-7 aspect-square w-full">
  @if (!showInitials && profile?.photo) {
    <div
      data-qa="avatar-photo"
      class="absolute overflow-hidden inset-0">
      <img
        class="w-full h-full object-cover"
        [src]="profile.photo"
        alt="avatar"
        (error)="onPhotoError()"
      >
    </div>
  }
  @if (showInitials) {
    <div
      data-qa="avatar-initials"
      class="absolute inset-0 flex text-center justify-center items-center {{initialsCssClasses}}">
      {{ initials }}
    </div>
  }
</div>
